import { render } from "./ReadMoreLess.vue?vue&type=template&id=0d39410e"
import script from "./ReadMoreLess.vue?vue&type=script&lang=js"
export * from "./ReadMoreLess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__